import { useSearchParams } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

export function useLoginPage() {
  const [searchParams] = useSearchParams();
  const { login } = useAuth();
  const redirectPath = searchParams.get('redirect') || '/triagem';
  const error = searchParams.get('error');

  const handleLogin = () => {
    if (redirectPath.startsWith('/')) {
      void login(redirectPath);
      return;
    }

    window.location.href = `/api/auth/login?redirect=${encodeURIComponent(redirectPath)}`;
  };

  return { error, handleLogin };
}